export const urlForConversation = (conversationId: number | string) =>
  `/conversations/${conversationId}`

export const urlForCampaign = (campaignId: number | string) => `/campaigns/${campaignId}`

export const prefixUrlWithHttp = (link?: string): string | undefined => {
  if (!link) return link

  const VALID_PREFIXES = ['http://', 'https://', 'mailto:']

  for (const prefix of VALID_PREFIXES) {
    if (link.startsWith(prefix)) {
      return link
    }
  }

  return `http://${link}`
}

export const getURLSearchParam = (key: string): string | null => {
  return new URLSearchParams(window.location.search.substr(1)).get(key)
}

export const getURLSearchParams = (): URLSearchParams => {
  return new URLSearchParams(window.location.search.substr(1))
}

export const getUrlFragment = (url: string): string => {
  const fragmentLocation = url.indexOf('#')
  let fragment = fragmentLocation > 0 ? `${url.substring(fragmentLocation)}` : ''
  if (fragment.indexOf('?') > 0) fragment = fragment.substring(0, fragment.indexOf('?'))

  return fragment.length > 1 ? fragment : ''
}

export const stripParams = (url: string | undefined): string => {
  if (!url) return ''
  const parsed = new URL(url)
  return parsed.origin + parsed.pathname
}